export { Label } from "./Label";
export { Badge } from "./Badge";

export type { BadgeType } from "./Badge";
